import { withBelvederePublicAsset } from "./belvedereRoomImages";
import { royalTulipTbilisiContract } from "./royalTulipTbilisiContractData";
import { ROYAL_TULIP_HERO_IMAGE } from "./royalTulipTbilisiHotelMedia";

export const ROYAL_TULIP_DEFAULT_ROOM_IMAGE = ROYAL_TULIP_HERO_IMAGE;

const ROOM_IMAGE_BY_KEY = {
  standard: "/campaigns/royal-tulip-tbilisi/gallery-03.jpg",
  family: "/campaigns/royal-tulip-tbilisi/gallery-04.jpg",
};

export function getRoyalTulipRoomImageUrl(imageKey) {
  const path = ROOM_IMAGE_BY_KEY[imageKey] || ROYAL_TULIP_DEFAULT_ROOM_IMAGE;
  return withBelvederePublicAsset(path);
}

function inferRoyalTulipImageKey({ roomId, roomCode, name, imageKey } = {}) {
  const explicit = String(imageKey || "").trim().toLowerCase();
  if (explicit === "family" || explicit === "standard") return explicit;

  const id = String(roomId || "").toLowerCase();
  if (id.includes("family")) return "family";
  if (id.includes("standard")) return "standard";

  const code = Number(roomCode);
  if (Number.isFinite(code) && code > 0) {
    const room = (royalTulipTbilisiContract.roomTypes || []).find(
      (row) => Number(row.code) === code,
    );
    if (room?.imageKey) return String(room.imageKey);
  }

  const blob = `${name || ""} ${id}`.toLowerCase();
  if (/family|משפחה/.test(blob)) return "family";
  return "standard";
}

/** Customer-offer room photo for Tbilisi — never Belvedere / Crete assets. */
export function resolveRoyalTulipOfferRoomImage(meta = {}) {
  return getRoyalTulipRoomImageUrl(inferRoyalTulipImageKey(meta));
}

export function resolveRoyalTulipRoomImageForOffer(quote) {
  const rows = Array.isArray(quote?.roomBreakdown) ? quote.roomBreakdown : [];
  const rooms = [quote?.room, ...rows.map((row) => row?.room)].filter(Boolean);
  for (const room of rooms) {
    if (room?.imageUrl) return room.imageUrl;
    if (room?.imageKey) return getRoyalTulipRoomImageUrl(room.imageKey);
  }
  return resolveRoyalTulipOfferRoomImage({
    roomId: quote?.room?.id || quote?.roomId,
    roomCode: quote?.room?.code ?? quote?.roomCode,
    name: quote?.room?.name || quote?.name,
    imageKey: quote?.room?.imageKey || quote?.imageKey,
  });
}
